import React from 'react';
import InnerHTML from '@Components/InnerHTML';
import { ButtonWithIcon } from '@els/els-react--button';
import { addUrlProtocol } from '@Utils/String';
import isEmpty from 'lodash/isEmpty';
import findKey from 'lodash/findKey';
import Catalyst from '@Services/Catalyst';
import HoverTooltip from '@Components/HoverTooltip';
import './SubstanceCommercialSupplierInfo.scss';

// eslint-disable-next-line import/prefer-default-export
export function SubstanceCommercialSupplierInformationCellProduct(props) {
  const {
    rcProductName,
    catalogProductNumber,
    suppliersProductNumber,
    suppliersSKU,
    productUrl,
    sdsUrl,
    casRegistryNumbers,
    supplierName,
  } = props;
  const linkId = catalogProductNumber || suppliersProductNumber || suppliersSKU;
  const linkTypes = {
    catalogProductNumber: 'Identification Number',
    suppliersProductNumber: 'Supplier Product Number',
    suppliersSKU: 'Supplier SKU',
  };
  const linkType = linkTypes[findKey(props, (value) => value === linkId)] || 'Catalog ID';

  const analyticsContent = {
    id: casRegistryNumbers, // CAS number
    id2: suppliersProductNumber, // Supplier Product Number
    id3: rcProductName, // Product
  };
  const analyticsLink = {
    type: 'Supplier Information',
    destination: supplierName,
  };

  const onSDSLinkClick = (url) => {
    // AA
    Catalyst.trackLinkOut(
      {
        ...analyticsContent,
        linkOut: 'supplier-info:sds', // v37
      },
      {
        ...analyticsLink,
        location: url, // Full URL
        name: 'SDS',
      }
    );
    window.open(url, '_blank');
  };

  const isSuppliersProductNumberLinkType = linkType === 'Supplier Product Number';

  const onSupplierProductNumberLinkClick = (url) => {
    if (isSuppliersProductNumberLinkType) {
      // AA
      Catalyst.trackLinkOut(
        {
          ...analyticsContent,
          linkOut: 'supplier-info:supplier-product-number',
        },
        {
          ...analyticsLink,
          location: url, // Full URL
          name: suppliersProductNumber,
        }
      );
    }

    window.open(url, '_blank');
  };

  return (
    <td className="column-product">
      {rcProductName && <InnerHTML tag="span" className="productName" html={rcProductName} />}
      {!isEmpty(casRegistryNumbers) && (
        <>
          <br />
          <HoverTooltip tooltip="CAS Number" theme="simple">
            <InnerHTML tag="span" html={casRegistryNumbers} />
          </HoverTooltip>
        </>
      )}
      <div className="column-product-group-item">
        {(catalogProductNumber || suppliersProductNumber || suppliersSKU) && productUrl && (
          <>
            <br />
            <HoverTooltip tag="span" tooltip={linkType} theme="simple">
              <ButtonWithIcon
                type="link"
                onClick={() => {
                  onSupplierProductNumberLinkClick(addUrlProtocol(productUrl));
                }}
                sprite="UpRight"
                size="small"
                className="blue"
                iconRight
                linkIconSize="xs"
                aria-label="Supplier Product Number">
                <InnerHTML tag="span" html={linkId} />
              </ButtonWithIcon>
            </HoverTooltip>
          </>
        )}

        {linkId && !productUrl && (
          <HoverTooltip tooltip={linkType} theme="simple">
            <InnerHTML tag="span" html={linkId} />
          </HoverTooltip>
        )}
        {sdsUrl && (
          <HoverTooltip tag="span" tooltip="Safety Data Sheets" theme="simple">
            <ButtonWithIcon
              type="link"
              onClick={() => onSDSLinkClick(addUrlProtocol(sdsUrl))}
              sprite="UpRight"
              size="small"
              className="blue sds"
              iconRight
              linkIconSize="xs"
              aria-label="SDS">
              <InnerHTML tag="span" html="Safety Data Sheets" />
            </ButtonWithIcon>
          </HoverTooltip>
        )}
      </div>
    </td>
  );
}
